import React, { FC } from "react";
import { Button, Select } from "antd";
import { useTranslation } from "react-i18next";
import cn from "classnames";

import classes from "./DownloadButton.module.scss";
import { ReactComponent as DownloadImage } from "assets/images/svg/dowload.svg";

type fileTypes = {
	id: number;
	value: string;
	label: string;
};
type Props = {
	fileTypes?: fileTypes[];
	extraClass?: string;
	isPaginationVisible?: boolean;
	isTableBottom?: boolean;
	handleDownload?: any;
};

const DownloadButton: FC<Props> = ({ isTableBottom = true, handleDownload }) => {
	const { t } = useTranslation();

	// fileTypes,

	const fileTypes = [
		{ id: 0, value: "xls", label: "XLS" },
		{ id: 1, value: "pdf", label: "PDF" },
		{ id: 2, value: "doc", label: "DOC" }
	];

	const content = (
		<div className={classes["download__button"]}>
			<DownloadImage />
			<span className={`${classes.label} mr-10`}>{t("Юклаш")}:</span>
			<Select defaultValue={"xls"} size={"large"} options={fileTypes} className={"mr-10 radius-8"} />
			<Button onClick={handleDownload} size={"large"} className={"pl-20 pr-20"}>
				{t("Юклаш")}
			</Button>
		</div>
	);

	if (isTableBottom) return content;

	return <div className={cn(classes.download__button)}>{content}</div>;
};

export default DownloadButton;
